<template>
	<el-card class="box-card"  style="margin-top: 20px">
	  <div slot="header" class="clearfix">
	    <span>期刊发文统计</span>
	  </div>
	  <div id="countChart" ref="countChart" :style="{width: '100%', height: '400px'}"></div>
	</el-card>
</template>

<script>
	export default {
		name: "countChart",
		data(){
			return{
				url: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
				activeName: 'first',
				checked:false
			}
		},
		methods:{
			countChart(){
				let typeListSize = '1';
				let typeArr = [];
				let typeArr2 = [];
				if (typeListSize > 0) {
					typeArr['0'] = '其他';
					typeArr2['0'] = {value:'0', name:'其他'};
				}
				let option = {
					title: {
						text: ''
					},
					tooltip: {
						trigger: 'item',
						formatter: "{b}: {c} ({d}%)"
					},
					legend: {

						data:typeArr,
						x: 'left',
//                        left: 10
						orient: 'vertical',
					},
					series: [
						{
							type:'pie',
							radius: ['38%', '83%'],
							center: ['50%', '66%'],

							avoidLabelOverlap: false,
							label: {
								normal: {
									show: false,
									position: 'center'
								},
								emphasis: {
									show: true,
									textStyle: {
										fontSize: '15',
										fontWeight: 'bold'
									}
								}
							},
							labelLine: {
								normal: {
									show: false
								}
							},
							data:typeArr2
						}
					]
				};
				let countChart = this.$echarts.init(document.getElementById('countChart'));
				countChart.setOption(option);
			}
		},
		mounted() {
			this.countChart()
		}

	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/count-chart.vue